import { render, staticRenderFns } from "./BreadcrumbItem.vue?vue&type=template&id=4dd4ef6a&scoped=true&"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4ef6a",
  null
  
)

export default component.exports